// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"d2675f4e","148":"1a733fc6","274":"efa314cb","420":"77b908d7","511":"7c1aced8","585":"4bfe5383","593":"c7736b84","706":"0fba33e7"}[chunkId] + ".chunk.js";
};